import http from "@/services/http";
import {useAuth} from "@/services/auth.js";

export const seles = () => {
  const auth = useAuth();

  async function list(page = 1) {
    let retorno;
    try {
        const {data} = await http.get(`/sales?page=${page}`, auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function show(id) {
    let retorno;
    try {
        const {data} = await http.get('/sales/' + id, auth.getBearer());
        retorno = data;
      } catch (error) {
        console.log(error?.response?.data);
      }
    return retorno;
  }

  async function cancel(id, password) {
    try {
      const {data} = await http.post('/sales/' + id + '/cancel', {password}, auth.getBearer());
      return {success: true, venda: data};
    } catch (error) {
      console.log(error?.response?.data);
      // Ex.: senha incorreta ou venda já cancelada (ver
      // SaleController::cancel) — a tela precisa do motivo real.
      return {success: false, message: error?.response?.data?.message ?? 'Não foi possível cancelar a venda.'};
    }
  }

  return {list, show, cancel}
}